import styled from "@emotion/styled"
import type { PIconProps } from "@porsche-design-system/components-react"
import { PHeading, PIcon, PText } from "@porsche-design-system/components-react"
import { spacingStaticXs, spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import type { Campaign } from "@slfinrtl/ui-bff-routes"
import { defineMessages, FormattedMessage } from "react-intl"

const messages = defineMessages({
	titleNoRestrictions: {
		defaultMessage: "No restrictions.",
		id: "vehicleDetails.overview.campaigns.noRestrictions.title",
	},
	titleStopDelivery: {
		defaultMessage: "Delivery is not possible.",
		id: "vehicleDetails.overview.campaigns.stopDelivery.title",
	},
	titleStopMarketing: {
		defaultMessage: "Marketing is not possible.",
		id: "vehicleDetails.overview.campaigns.stopMarketing.title",
	},
})

export const CampaignList = ({ campaigns }: { campaigns: Campaign[] }) => {
	return (
		<Layout>
			{campaigns.map((campaign) => {
				const icon = getCampaignIcon(campaign)
				return (
					<div key={campaign.id}>
						<IconHeadingWrapper>
							{icon && <PIcon {...icon} />}
							<PHeading size="sm">{campaign.title ?? campaign.id}</PHeading>
						</IconHeadingWrapper>
						{campaign.stopMarketing && (
							<PText>
								<FormattedMessage {...messages.titleStopMarketing} />
							</PText>
						)}
						{campaign.stopDelivery && (
							<PText>
								<FormattedMessage {...messages.titleStopDelivery} />
							</PText>
						)}
						{!campaign.stopDelivery && !campaign.stopMarketing && (
							<PText>
								<FormattedMessage {...messages.titleNoRestrictions} />
							</PText>
						)}
					</div>
				)
			})}
		</Layout>
	)
}

function getCampaignIcon(campaign: Campaign): PIconProps | undefined {
	if (campaign.stopMarketing) {
		return {
			color: "error",
			name: "exclamation",
		}
	}
	if (campaign.stopDelivery) {
		return {
			color: "warning",
			name: "warning",
		}
	}
}

const Layout = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticMd};
`

const IconHeadingWrapper = styled.div`
	display: flex;
    gap: ${spacingStaticXs};
`
